import React, { useEffect } from "react";
import Layout from '../form-layout'

// Intro dialogue — matches the "//Intro dialogue" text at the top of both Form A and
// Form B docs. The router question (glp1-router.jsx) follows immediately after this,
// with no intermediate marketing/awareness screens, and no name capture.
export default function Step1({ onNext, goToStep, onBack }) {
  useEffect(() => {
    document.title = "Slimming Doctor";
  }, []);

  const handleContinue = () => {
    onNext();
  };

  return (
    <Layout onBack={onBack} isFirstStep={true} goToStep={goToStep}>
      <h1 className="text-[28px] font-medium text-[#000000] mb-4">Welcome to Slimming Doctor</h1>

      <p className="text-sm sm:text-[14px] text-[#000000] mb-3">Let's find the right treatment for you.</p>

      <p className="text-sm sm:text-[14px] text-[#000000] mb-1">
        Answer a few short questions so our doctor can confirm this treatment is safe and right for you
        personally.
      </p>
      <p className="text-sm sm:text-[14px] font-semibold text-[#000000] mb-4">Takes about 5 minutes.</p>

      <p className="text-sm sm:text-[14px] font-medium text-[#000000] mb-2">After completing this you get:</p>
      <ul className="list-disc list-inside space-y-1 text-[14px] text-[#000000] mb-6">
        <li>Your personalised treatment recommendation from the doctor</li>
        <li>Review from the doctor who checks your answers individually</li>
        <li>Medication delivered within 24 hours of approval</li>
      </ul>

      <button
        type="button"
        onClick={handleContinue}
        className="w-full bg-[#35C3D9] hover:bg-[#27AAC0] text-white text-sm font-semibold rounded-lg py-3 transition-colors"
      >
        Start eligibility with Slimming Doctor
      </button>

      <p className="text-xs text-gray-500 text-center mt-2">Your answers are confidential.</p>
    </Layout>
  );
}
